import { render, staticRenderFns } from "./CustomRadioField.vue?vue&type=template&id=3122e824&scoped=true&"
import script from "./CustomRadioField.vue?vue&type=script&lang=js&"
export * from "./CustomRadioField.vue?vue&type=script&lang=js&"
import style0 from "./CustomRadioField.vue?vue&type=style&index=0&id=3122e824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3122e824",
  null
  
)

export default component.exports